module.exports = __webpack_public_path__ + "img/cut5icon.f6999d43.png";